import React from 'react';
import { GenericFormModal } from './GenericFormModal';
import { SeriesFormFields } from '../forms/SeriesFormFields';

export function SeriesFormModal({ 
  isOpen, 
  onClose, 
  series,
  onSubmit
}) {
  const [localFormData, setLocalFormData] = React.useState(series || {
    name: '',
    description_de: '',
    description_en: ''
  });

  // Update localFormData when series prop changes
  React.useEffect(() => {
    if (series) {
      setLocalFormData(series);
    } else {
      setLocalFormData({
        name: '',
        description_de: '',
        description_en: ''
      });
    }
  }, [series, isOpen]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setLocalFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(e, localFormData);
      onClose();
    } catch (error) {
      console.error('SeriesFormModal submit error:', error);
      // Modal bleibt offen bei Fehler
    }
  };

  return (
    <GenericFormModal 
      isOpen={isOpen} 
      onClose={onClose}
      title={series ? 'Serie bearbeiten' : 'Neue Serie'}
      size="xl"
    >
      <SeriesFormFields
        formData={localFormData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isEdit={!!series}
      />
    </GenericFormModal>
  );
}